import './polyfill.js';
import './missing-services.js';
import getServiceOverride$1 from './notifications.js';
import getServiceOverride$2 from './dialogs.js';
function getServiceOverride(container) {
    return {
        ...getServiceOverride$1(container),
        ...getServiceOverride$2(container)
    };
}
export { getServiceOverride as default };
